// Эмодзи по категориям — для быстрого сканирования глазами в списках, чипах и селектах.
const CATEGORY_EMOJI = {
    'ПРОДУКТЫ': '🛒',
    'МАШИНА': '🚗',
    'ЕДА НЕ ДОМА': '🍽️',
    'ТРАНСПОРТ': '🚌',
    'ЕДА НА РАБОТЕ': '🥪',
    'СВЯЗЬ': '📱',
    'РОДИТЕЛИ': '👵',
    'РАБОТА': '💼',
    'ПОДАРКИ': '🎁',
    'ПОДПИСКИ': '🔄',
    'ЖИВОПИСЬ': '🎨',
    'АЛКОГОЛЬ': '🍷',
    'ПИТОМЦЫ': '🐾',
    'ХОББИ': '🎲',
    'КНИГИ': '📚',
    'ОДЕЖДА': '👕',
    'ПУТЕШЕСТВИЯ': '✈️',
    'ТОВАРЫ ДЛЯ ДОМА': '🏠',
    'УЧЕБА': '🎓',
    'ИПОТЕКА': '🏦',
    'УХОД ЗА СОБОЙ': '💅',
    'ЖКХ': '💡',
    'ЗДОРОВЬЕ': '🏥',
    'АВТОКРЕДИТ': '🚙',
    'УСАДЬБА': '🌳',
    'ДР': '🎂',
    'РАЗВЛЕЧЕНИЯ': '🎉',
    'НАЛОГИ И ШТРАФЫ': '🧾',
    'БЛАГОТВОРИТЕЛЬНОСТЬ': '🤝',
    'СВАДЬБА': '💒',
    'ПОПОЛНЕНИЕ': '💰',
    'КОРРЕКТИРОВКА': '⚖️'
};

export const categoryEmoji = (category) => {
    if (!category) return '💸';
    return CATEGORY_EMOJI[category.toUpperCase()] || '💸';
};

// Название месяца по-русски (единый источник для всех компонентов)
export const monthName = (month) =>
    new Date(2000, month - 1, 1).toLocaleString('ru-RU', { month: 'long' });

// Отображаемое имя счёта по его техническому name — единый источник для форм и списков
const ACCOUNT_NAMES = {
    'family': 'Семейный счёт',
    'savings': 'Накопительный счёт'
};

export const accountDisplayName = (name) => ACCOUNT_NAMES[name] || name;

export default CATEGORY_EMOJI;
